import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { setLoading } from "../../reducer/auth/auth";
import { getMyGift, isOk, messageOf } from "../../services/gift";
import GiftCard from "./components/GiftCard";
import GiftCardActions from "./components/GiftCardActions";
import GiftSendPanel from "./components/GiftSendPanel";
import GiftPaymentDue from "./components/GiftPaymentDue";
import GiftDecisionDue from "./components/GiftDecisionDue";
import GiftCancelPanel from "./components/GiftCancelPanel";
import { GiftStatus } from "./MyGifts";
import "./gift.css";
import "./redeem.css";

// One of the purchaser's gifts: pay for a requested session, reprint / reshare the card.
export default function MyGift() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [gift, setGift] = useState(null);

  useEffect(() => {
    dispatch(setLoading(true));
    getMyGift(id).then((res) => {
      dispatch(setLoading(false));
      if (isOk(res)) {
        setGift(res.data.data);
      } else {
        toast.error(messageOf(res, "Gift not found."));
      }
    });
  }, [id]);

  if (!gift) {
    return <div className="vsr-page vsr-inner" />;
  }

  return (
    <div className="vsr-page vsr-inner">
      <div className="vsr-stack">
        <div className="vsr-page-head no-print">
          <div>
            <Link className="vsr-link" to="/my-gifts">
              &larr; My Gifts
            </Link>
            <h1 className="vsr-title vsr-title-left vsr-title-sm">Your VerySoul Gift</h1>
            <p className="vsr-lead vsr-lead-left">
              Covers a session up to{" "}
              <b>
                {gift.currency} {gift.max_price}
              </b>
            </p>
          </div>
          <GiftStatus status={gift.status} />
        </div>

        <div className="no-print">
          <GiftPaymentDue payment={gift.pending_payment} />
          <GiftDecisionDue gift={gift} onAnswered={setGift} />
        </div>

        <GiftSendPanel key={gift.status} gift={gift} />

        <div className="vsr-card vsr-card-panel">
          <GiftCard code={gift.code} qrSvg={gift.qr_svg} redeemUrl={gift.redeem_url} />
          {gift.status === "active" && <GiftCardActions code={gift.code} redeemUrl={gift.redeem_url} />}
        </div>

        <GiftCancelPanel gift={gift} onCancelled={setGift} />
      </div>
    </div>
  );
}
